// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'emai... Remove this comment to see the full error message
import EmailConfirmBarPrebuilt from 'email-confirm-ui/prebuilts/HubHttpPrebuilt';
export default {
  injectEmailConfirmBar() {
    return new EmailConfirmBarPrebuilt();
  },
  setup() {
    return this.injectEmailConfirmBar();
  }
};